/*
 PolitykaCookies

 Tresc polityki plikow cookies
  
 historia: 
  PM 2021-10-27 - start
*/

import * as React from 'react';

import { Typography } from '@material-ui/core';

class PolitykaCookies extends React.Component<any, any> {

    //PM 2021-11-05
    //variant='body2'
    //poprawka DOM
    render() {

        return (
            <React.Fragment>
                <Typography variant='body2'><b>Czym są cookies?</b></Typography>
                <Typography variant='body2'>Cookies z angielska zwanymi ciasteczkami to nic innego jak niewielkie dane informatyczne zapisane w formacie tekstowym, wysyłane przez serwer www i zapisywane na urządzeniu końcowym czyli komputerze, tablecie itp.</Typography>
                <br />
                <Typography variant='body2'><b>Do czego są wykorzystywane?</b></Typography>
                <Typography variant='body2'>Pliki cookies zawierają różnego rodzaju dane na temat użytkownika danego urządzenia odwiedzającego określoną stronę internetową. Najczęściej służą do automatycznego zapamiętywania danych użytkownika przy wielokrotnych odwiedzinach, dostosowania strony do preferencji użytkownika, optymalizacji korzystania z nich oraz anonimowych statystyk.</Typography>
                <br />
                <Typography variant='body2'><b>Możliwe rodzaje plików cookies w ramach strony</b></Typography>
                <Typography variant='body2'>Sesyjne – ściśle związane z konkretną wizytą użytkownika na stronie.</Typography>
                <Typography variant='body2'>Stałe – pozostają zapisane na urządzeniu użytkownika do czasu usunięcia ich przez niego samego lub wygasają zgodnie z konfiguracją i parametrami plików cookies.</Typography>
                <br />
                <Typography variant='body2'><b>Usunięcie plików cookies</b></Typography>
                <Typography variant='body2'>Domyślą opcją działania wszystkich przeglądarek internetowych jest obsługa czyli zezwolenie na zapis plików cookies na dysku urządzenia. Można te ustawienie zmienić tak aby domyślną opcjąbyło blokowanie korzystania z plików cookies. Wówczas niektóre funkcjonalności strony www mogą nie być w pełni możliwe do wykorzystania.</Typography>
            </React.Fragment>
        );
    }
}

export default PolitykaCookies;
